import React from 'react';
import styles from './reviews.module.css';

interface ReviewFabProps {
  onClick: () => void;
  title?: string;
}

export const ReviewFab: React.FC<ReviewFabProps> = ({
  onClick,
  title = 'Laisser un commentaire sur cette scène',
}) => {
  return (
    <button
      type="button"
      className={styles.fab}
      onClick={onClick}
      title={title}
      aria-label={title}
    >
      💬
    </button>
  );
};
